<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';
import { currentUserWsRoles } from '../utils/roles';

const AppTrialExpiredWarning = defineComponent({
    name: 'AppTrialExpiredWarning',

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const state = reactive({
            isSubscriptionAdmin: currentUserWsRoles.isSubscriptionAdmin,
        });

        const isTrialExpired = initAppData.currentWs.isShowTrialPeriodIsExpired;

        return {
            state,
            isTrialExpired,
        };
    },
});

export default AppTrialExpiredWarning;
</script>

<template>
  <div v-if="isTrialExpired" class="red white--text pa-2 font-weight-semibold" style="font-size: 14px;">
    Your free trial has expired. 
    <template v-if="state.isSubscriptionAdmin">
      Please subscribe to one of our plans to continue working. 
      <router-link to="/managesubscription" class="white--text">
        Go to plan and billing
      </router-link>
    </template>
  </div>
</template>

<style lang='scss' scoped></style>